import { render, staticRenderFns } from "./DESTALT2.vue?vue&type=template&id=4bf47c97&scoped=true&"
import script from "./DESTALT2.vue?vue&type=script&lang=js&"
export * from "./DESTALT2.vue?vue&type=script&lang=js&"
import style0 from "./DESTALT2.vue?vue&type=style&index=0&id=4bf47c97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf47c97",
  null
  
)

export default component.exports